import React,
{
  useCallback,
  useEffect,
  useState 
} from 'react'

import { Div } from '@driftt/tide-core'
import { Table } from '@driftt/tide-table'
import { getMarketoSyncErrors } from 'api/imports'
import Paginator from 'components/Paginator'

import {
  Columns,
  RowFormatter 
} from '../MarketoTableFormatters'

import './style.css'

const MarketoImportLogs = ({ orgId }) =>  {
  const [syncErrorList, setSyncErrorList] = useState([])
  const [index, setIndex] = useState(0)
  const [currentPage, setCurrentPage] = useState(0)
  const [currentSize, setCurrentSize] = useState(25)
  const [isLoading, setIsLoading] = useState(true)
  
  const getMarketoErrors = useCallback(() => {
    async function fetch() {
      try {
        const { data: erroredSyncs } = await getMarketoSyncErrors(orgId, index, currentSize)
        setSyncErrorList(erroredSyncs)
        setIsLoading(false)
      } catch(e) {
        console.warn(e)
      }
    }
    fetch()
  },[orgId, index, currentSize])

  const nextPage = () => {
    setCurrentPage(currentPage + 1)
    setIndex(index + currentSize)
  }

  const previousPage = () => {
    setCurrentPage(currentPage - 1)
    setIndex(index - currentSize)
  }

  const changeSize = ({ value }) => {
    setCurrentSize(value)
  }

  useEffect(() => getMarketoErrors(), [currentPage, currentSize, getMarketoErrors])

  return (
    <Div className="marketo-sync-logs--container">
      <Table 
        className="marketo-sync-logs--table"
        columns={Columns}
        isWorking={isLoading}
        data={!!syncErrorList && syncErrorList.map(RowFormatter)}
      />
      <Paginator goForward={nextPage} changeSize={changeSize}
        goBackward={previousPage} totalPages={200}
        index={currentPage} size={currentSize} />
    </Div>
  )
  
}

export default MarketoImportLogs
